import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("manik_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve an image path (external URL vs backend-stored image)
export const resolveImg = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${BACKEND_URL}${src}`;
};

export const setAdminToken = (t) => localStorage.setItem("manik_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("manik_admin_token");
export const getAdminToken = () => localStorage.getItem("manik_admin_token");
